import { DriverDto, LogbookRecordViolation, LogbookRecordWarning } from '@fleet-beat/api';

export interface LogsModel {
  driverId?: string;
  driver?: DriverDto;
  onlineStatus?: boolean;
  isDeviceConnected?: boolean;
  truckNo?: string;
  drive?: number;
  break?: number;
  shift?: number;
  cycle?: number;
  recap?: number;
  lastSync?: string;
  warningsList?: LogbookRecordWarning[];
  violationsList?: LogbookRecordViolation[];
}
